import { TruncatePipe } from './../pipes/truncate.pipe';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { ColorSketchModule } from 'ngx-color/sketch';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ChartsModule } from 'ng2-charts';
import { QuillModule } from 'ngx-quill';
// Interfaces
import { INavigationBarItem } from '../models/models';
// Components
import { AvatarComponent } from '@shared/components/avatar/avatar.component';
import { MaterialModule } from '@shared/material/material.module';
import { MomentModule } from 'ngx-moment';
import { CalendarDatePipe } from '@shared/pipes/calendar-date.pipe';
import { UserSettingsComponent } from '@shared/components/user-settings/user-settings.component';
import { DragScrollModule } from 'ngx-drag-scroll';
import { CapitalLetterPipe } from '@shared/pipes/capital-letter.pipe';
import { BranchFilterComponent } from '@shared/components/branch-filter/branch-filter.component';
import { CalendarComponent } from '@shared/components/date-filter/calendar/calendar.component';
import { PlaceHolderLoaderComponent } from '@shared/components/place-holder-loader/place-holder-loader.component';
import { PositionsFilterComponent } from '@shared/components/positions-filter/positions-filter.component';
import { SearchInputComponent } from '@shared/components/search-input/search-input.component';
import { MinuteSecondsPipe } from '@shared/pipes/minuteSeconds.pipe';
import { ObjectKeysPipe } from '@shared/pipes/objectKey.pipe';
import { ShortNumberPipe } from '@shared/pipes/shortNumbers.pipe';
import { PaginatorModule } from '@shared/components/paginator/paginator.module';
import { DateFilterComponent } from '@shared/components/date-filter/date-filter.component';
import { EventTypeFilterComponent } from '@shared/components/event-type-filter/event-type-filter.component';
import { EmployeeFilterComponent } from '@shared/components/employee-filter/employee-filter.component';
import { CustomSnackBarComponent } from '@shared/components/customSnackBar/custom-snack-bar.component';
import { ListColumnTitleComponent } from '@shared/components/list-column-title/list-column-title.component';
import { ListRowWrapperComponent } from '@shared/components/list-row-wrapper/list-row-wrapper.component';
import { ListWrapperComponent } from '@shared/components/list-wrapper/list-wrapper.component';
import { SkeletonListComponent } from '@shared/components/skeleton-list/skeleton-list.component';
import { ActionsMenuComponent } from '@shared/components/actions-menu/actions-menu.component';
import { UserMenuComponent } from '@shared/components/user-menu/user-menu.component';
import { RequestFilterComponent } from '@shared/components/request-filter/request-filter.component';
import { ChipFilterComponent } from '@shared/components/chip-filter/chip-filter.component';
import { IsEmptyPipe } from '@shared/pipes/is-empty.pipe';
import { WebCamProfileDialogComponent } from '@shared/components/web-cam-profile-dialog/web-cam-profile-dialog.component';
import { ImageProfileComponent } from '@shared/components/image-profile/image-profile.component';
import { ItemInformationComponent } from '@shared/components/item-information/item-information.component';
import { YearsOldPipe } from '@shared/pipes/years-old.pipe';
import { IdentityDocumentCustomPipe } from '@shared/pipes/identity-document-custom.pipe';
import { GoogleAutocompleteDirective } from '@shared/directives/google-autocomplete.directive';
import { SnackBarComponent } from '@shared/components/snack-bar/snack-bar.component';
import { MaritalStatusPipe } from '@shared/pipes/marital-status.pipe';
import { ChipsComponent } from '@shared/components/chips/chips.component';
import { ChipsAutocompleteComponent } from '@shared/components/chips-autocomplete/chips-autocomplete.component';
import { MatSelectSearchComponent } from '@shared/components/chips-autocomplete/mat-select-search/mat-select-search.component';
import { SwalCustomComponent } from '@shared/components/swal-custom/swal-custom.component';
import { SnackbarSuccessComponent } from '@shared/components/snackbar-success/snackbar-success.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MultiSelectSearchComponent } from '../components/multi-select-search/multi-select-search.component';
import { SnackbarConfirmComponent } from '../components/snackbar-confirm/snackbar-confirm.component';
import { ModalHeaderComponent } from '../components/modal-header/modal-header.component';
import { CityNamePipe } from '../pipes/city-name.pipe';
import { ScrollWithButtonsComponent } from '@shared/components/scroll-with-buttons/scroll-with-buttons.component';
import { UploadFileComponent } from '@shared/components/upload-file/upload-file.component';
import { ModalFooterSaveComponent } from '@shared/components/modal-footer-save/modal-footer-save.component';
import { SnackbarFailureComponent } from '@shared/snackbar-failure/snackbar-failure.component';
import { SnackbarConfirmFailureComponent } from '@shared/components/snackbar-confirm-failure/snackbar-confirm-failure.component';
import { SnackbarWarningComponent } from '@shared/components/snackbar-warning/snackbar-warning.component';
import { NewVersionAvailableComponent } from '@shared/components/new-version-available/new-version-available.component';

// Exports
export { INavigationBarItem };

@NgModule({
  declarations: [
    CalendarDatePipe,
    UserSettingsComponent,
    TruncatePipe,
    TruncatePipe,
    CapitalLetterPipe,
    AvatarComponent,
    BranchFilterComponent,
    CalendarComponent,
    PlaceHolderLoaderComponent,
    PositionsFilterComponent,
    SearchInputComponent,
    MinuteSecondsPipe,
    ObjectKeysPipe,
    ShortNumberPipe,
    DateFilterComponent,
    EventTypeFilterComponent,
    EmployeeFilterComponent,
    CustomSnackBarComponent,
    ListColumnTitleComponent,
    ListRowWrapperComponent,
    ListWrapperComponent,
    SkeletonListComponent,
    ActionsMenuComponent,
    UserMenuComponent,
    RequestFilterComponent,
    ChipFilterComponent,
    IsEmptyPipe,
    WebCamProfileDialogComponent,
    ImageProfileComponent,
    ItemInformationComponent,
    YearsOldPipe,
    IdentityDocumentCustomPipe,
    GoogleAutocompleteDirective,
    SnackBarComponent,
    MaritalStatusPipe,
    ChipsComponent,
    ChipsAutocompleteComponent,
    MatSelectSearchComponent,
    SwalCustomComponent,
    SnackbarSuccessComponent,
    MultiSelectSearchComponent,
    SnackbarSuccessComponent,
    SnackbarConfirmComponent,
    SnackbarConfirmFailureComponent,
    ModalHeaderComponent,
    CityNamePipe,
    ScrollWithButtonsComponent,
    UploadFileComponent,
    ModalFooterSaveComponent,
    SnackbarFailureComponent,
    SnackbarWarningComponent,
    NewVersionAvailableComponent
  ],
  imports: [
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ColorSketchModule,
    NgxMaterialTimepickerModule,
    ChartsModule,
    MomentModule,
    DragScrollModule,
    QuillModule.forRoot(),
    DragScrollModule,
    PaginatorModule,
    NgxMatSelectSearchModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MomentModule,
    MaterialModule,
    NgxMaterialTimepickerModule,
    ChartsModule,
    CalendarDatePipe,
    UserSettingsComponent,
    DragScrollModule,
    QuillModule,
    TruncatePipe,
    CapitalLetterPipe,
    AvatarComponent,
    BranchFilterComponent,
    CalendarComponent,
    PlaceHolderLoaderComponent,
    PositionsFilterComponent,
    SearchInputComponent,
    MinuteSecondsPipe,
    ObjectKeysPipe,
    ShortNumberPipe,
    DateFilterComponent,
    EventTypeFilterComponent,
    EmployeeFilterComponent,
    CustomSnackBarComponent,
    ListColumnTitleComponent,
    ListRowWrapperComponent,
    ListWrapperComponent,
    SkeletonListComponent,
    ActionsMenuComponent,
    UserMenuComponent,
    RequestFilterComponent,
    ChipFilterComponent,
    IsEmptyPipe,
    ImageProfileComponent,
    ItemInformationComponent,
    YearsOldPipe,
    IdentityDocumentCustomPipe,
    GoogleAutocompleteDirective,
    SnackBarComponent,
    MaritalStatusPipe,
    ChipsComponent,
    ChipsAutocompleteComponent,
    MatSelectSearchComponent,
    SwalCustomComponent,
    MultiSelectSearchComponent,
    SnackbarSuccessComponent,
    SnackbarConfirmComponent,
    SnackbarConfirmFailureComponent,
    ModalHeaderComponent,
    CityNamePipe,
    ScrollWithButtonsComponent,
    PaginatorModule,
    UploadFileComponent,
    ModalFooterSaveComponent,
    SnackbarFailureComponent,
    SnackbarWarningComponent,
    NewVersionAvailableComponent
  ],
  entryComponents: [
    SnackbarSuccessComponent,
    ModalFooterSaveComponent,
    SnackbarFailureComponent,
    SnackbarConfirmComponent,
    SnackbarConfirmFailureComponent,
    SnackbarWarningComponent,
  ],
})
export class SharedModule {}
